import { useMediaQuery, useTheme } from "@mui/material";
export var MAX_ITEMS_PER_ROW = {
    xs: 1,
    sm: 2,
    md: 4,
};
export var groupElementsIntoRows = function (elements) {
    var rows = [];
    elements.forEach(function (element) {
        if (element.startWithNewLine === false && rows.length > 0) {
            rows[rows.length - 1].push(element);
        }
        else {
            rows.push([element]);
        }
    });
    return rows;
};
export var chunkRow = function (items, maxItemsPerRow) {
    var chunks = [];
    for (var i = 0; i < items.length; i += maxItemsPerRow) {
        chunks.push(items.slice(i, i + maxItemsPerRow));
    }
    return chunks;
};
export var getItemGridSize = function (itemsInRow, isLast) {
    var xsFloor = Math.floor(12 / itemsInRow);
    return isLast ? 12 - xsFloor * (itemsInRow - 1) : xsFloor;
};
export var useMaxItemsPerRow = function () {
    var theme = useTheme();
    var isMdUp = useMediaQuery(theme.breakpoints.up("md"));
    var isSmUp = useMediaQuery(theme.breakpoints.up("sm"));
    if (isMdUp) {
        return MAX_ITEMS_PER_ROW.md;
    }
    if (isSmUp) {
        return MAX_ITEMS_PER_ROW.sm;
    }
    return MAX_ITEMS_PER_ROW.xs;
};
